import React, { useEffect, useMemo, useState } from 'react';
import { createContext } from '@shared/utils/createContext';
import { useGoogleMaps } from '@shared/core/google-maps/useGoogleMaps';

type JoyInteractableMapContext = {
  map?: google.maps.Map;
  setMap: React.Dispatch<React.SetStateAction<google.maps.Map | undefined>>;
  initialBounds?: google.maps.LatLngBounds;
  loadingPlaces: boolean;
  setLoadingPlaces: React.Dispatch<React.SetStateAction<boolean>>;
};

const [Provider, useJoyInteractableMapContext] = createContext<JoyInteractableMapContext>({ name: 'JoyInteractableMap' });

const JoyInteractableMapProvider: React.FC = ({ children }) => {
  const [googleMaps] = useGoogleMaps({ loadOnMount: true });
  const [map, setMap] = useState<google.maps.Map | undefined>();
  const [initialBounds, setInitialBounds] = useState<google.maps.LatLngBounds | undefined>();
  const [loadingPlaces, setLoadingPlaces] = useState(false);

  useEffect(() => {
    if (!map || !googleMaps) return;

    googleMaps.event.addListenerOnce(map, 'bounds_changed', () => {
      setInitialBounds(map.getBounds());
    });

    return () => {
      googleMaps.event.clearInstanceListeners(map);
    };
  }, [map, googleMaps]);

  const ctx = useMemo<JoyInteractableMapContext>(
    () => ({
      map,
      setMap,
      initialBounds,
      loadingPlaces,
      setLoadingPlaces,
    }),
    [initialBounds, loadingPlaces, map],
  );

  return <Provider value={ctx}>{children}</Provider>;
};

export { JoyInteractableMapProvider, useJoyInteractableMapContext };
